import { useMutation } from '@tanstack/react-query'
import { BackupShiftRequest, postBackupShift } from 'api/shift'
import { AxiosError } from 'axios'
import { useAuthContext } from 'components/auth'

interface UseBackupShiftMutation {
  shiftId: number
  onSuccess?: () => void
  onError?: (err: AxiosError) => void
}

export function useBackupShiftMutation(options: UseBackupShiftMutation) {
  const { shiftId, ...otherOptions } = options
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (data: BackupShiftRequest) => {
      if (!company?.id) {
        return
      }

      return postBackupShift(company.id, shiftId, data)
    },
    ...otherOptions,
  })
}
